<template lang="pug">
#waivers-tab
  spinner(v-if="settings.loading")
  b-notification(
    v-else-if="waivers.length === 0"
    :closable="false"
  )
    .has-text-centered No waivers
  b-table(
    v-else
    :data="waivers"
    @click="open"
  )
    template(slot-scope="props")
      b-table-column(label="Name") {{ props.row.name }}
      b-table-column(label="Created") {{ props.row.created_at | date }}
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from '@/components/Spinner';
import WaiverForm from '@/components/form/WaiverForm';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'waivers-tab',
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      waivers: getters.GET_WAIVERS,
      refresh: getters.GET_EVENTS_REFRESH,
    }),
  },
  async created() {
    this.settings.loading = true;
    await this.$store.dispatch(actions.DO_GET_WAIVERS, {});
    this.settings.loading = false;
  },
  data() {
    return {
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async getPage() {
      this.settings.loading = true;
      await this.$store.dispatch(actions.DO_GET_WAIVERS, {});
      this.settings.loading = false;
    },
    async open(waiver) {
      await this.$store.dispatch(actions.DO_GET_WAIVER, {
        id: waiver.id,
      });
      this.$buefy.modal.open({
        parent: this,
        component: WaiverForm,
        hasModalCard: true,
      });
    },
  },
  watch: {
    refresh(val) {
      if (val) this.getPage();
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/WaiversTab.vue